<label class="switch-wrapper d-flex align-items-center position-relative">
  <input
    type="checkbox"
    class="position-absolute"
    [(ngModel)]="value"
    (ngModelChange)="propagateChanges($event)"
    [disabled]="isDisabled"
  >
  <div class="switch-wrapper__switch d-flex align-items-center">
    <div class="switch-wrapper__switch__circle d-flex align-items-center justify-content-center"></div>
  </div>

  @if (text) {
    <p class="p2 m-l-8" [class.c-t-g-600]="isDisabled">{{ text }}</p>
  }
</label>
